import React, { memo, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import './ItemDropdownDownload.scss'
import { getMergedClassNames, getUniqueKey } from '../../utils/HTMLutils'
import { ChevronArrowDownIcon } from '../../assets/icons/ChevronArrowDownIcon'
import { CSSTransition } from 'react-transition-group'
import { PercentLoaderIcon } from '../../assets/icons/PercentLoaderIcon'
import { CloudDownloadIcon } from '../../assets/icons/CloudDownloadIcon'
const rootClassName = 'component-item-dropdown-download'
function ItemDropdownDownload(props) {
  const [id] = useState(props.id ? props.id : getUniqueKey())

  const getProps = () => {
    const p = {
      ...props,
      className: getMergedClassNames([
        rootClassName,
        props.className || '',
        props.opened ? 'opened' : 'closed'
      ]),
      onClick: () => {
        if (typeof props.onClick === 'function') {
          props.onClick()
        }
        if (typeof props.setOpened === 'function') {
          props.setOpened(!props.opened)
        }
      }
    }
    delete p.label
    delete p.opened
    delete p.setOpened
    delete p.closeOnOutClick
    delete p.closeOnEsc
    delete p.downloads
    return p
  }

  // OnOutClick
  useEffect(() => {
    const onHandleClick = (evt) => {
      if (evt.path) {
        if (
          document.querySelector(
            `#${id} .${rootClassName}-panel.panel-fade-enter-done`
          ) &&
          !evt.path.includes(document.querySelector(`#${id}`))
        )
          props.setOpened(false)
      } else {
        // FIREFOX
        let aux = evt.target
        let deveFechar = true
        while (aux && aux.id !== 'root') {
          if (
            aux &&
            aux.id &&
            aux.id === id &&
            aux.classList.contains(`${rootClassName}`)
          ) {
            deveFechar = false
            break
          }
          aux = aux.parentElement
        }
        if (deveFechar) {
          props.setOpened(false)
        }
      }
    }
    const onEscPress = (evt) => {
      if (evt.key === 'Escape') {
        props.setOpened(false)
      }
    }

    if (props.closeOnOutClick) {
      if (props.opened) {
        document.addEventListener('mousedown', onHandleClick)
      } else {
        document.removeEventListener('mousedown', onHandleClick)
      }
    }
    if (props.closeOnEsc) {
      if (props.opened) {
        document.addEventListener('keyup', onEscPress)
      } else {
        document.removeEventListener('keyup', onEscPress)
      }
    }
    return () => {
      document.removeEventListener('click', onHandleClick)
      document.removeEventListener('keyup', onEscPress)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.opened])

  return (
    <div className={`${rootClassName}-outer`} id={id}>
      <button {...getProps()}>
        <div className={`${rootClassName}-label`}>{props.label}</div>
        <div
          className={getMergedClassNames([
            `${rootClassName}-arrow`,
            props.opened ? 'up' : 'down'
          ])}
        >
          <ChevronArrowDownIcon />
        </div>
      </button>
      <CSSTransition
        in={props.opened}
        timeout={300}
        classNames='panel-fade'
        unmountOnExit
      >
        <div className={`${rootClassName}-panel`}>
          {props.downloads && props.downloads.length
            ? props.downloads.map((download, index) => {
                return (
                  <button
                    id={download.id || undefined}
                    className={`${rootClassName}-item ${
                      download.loading ? 'loading' : ''
                    }`}
                    onClick={(evt) => {
                      if (
                        !download.loading &&
                        typeof download.onClick === 'function'
                      ) {
                        download.onClick(evt)
                      }
                    }}
                    key={index}
                  >
                    <div className={`${rootClassName}-item-label`}>
                      {download.label}
                    </div>
                    <div className={`${rootClassName}-download-icon`}>
                      {download.loading ? (
                        <PercentLoaderIcon indefinido />
                      ) : (
                        <CloudDownloadIcon />
                      )}
                    </div>
                  </button>
                )
              })
            : undefined}
        </div>
      </CSSTransition>
    </div>
  )
}

ItemDropdownDownload.propTypes = {
  label: PropTypes.string,
  opened: PropTypes.bool,
  setOpened: PropTypes.func,
  closeOnOutClick: PropTypes.bool,
  closeOnEsc: PropTypes.bool,
  downloads: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      loading: PropTypes.bool,
      onClick: PropTypes.func
    })
  )
}

ItemDropdownDownload.defaultProps = {
  closeOnOutClick: true,
  closeOnEsc: true
}

export default memo(ItemDropdownDownload)
